export const MAIN_CLASS_NAME = 'api-keys-page';
